import { render } from "./BravoConfirm.vue?vue&type=template&id=1167b9d4&scoped=true"
import script from "./BravoConfirm.vue?vue&type=script&lang=js"
export * from "./BravoConfirm.vue?vue&type=script&lang=js"

import "./BravoConfirm.vue?vue&type=style&index=0&id=1167b9d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1167b9d4"]])

export default __exports__